import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog'
import React from 'react'

export interface RemoveProductTypeWarningProps {
    onCancel: VoidFunction
    onRemoveProject?: VoidFunction
    isDisplayed: boolean
}

const RemoveProductTypeWarning: React.FC<RemoveProductTypeWarningProps> = ({
    onCancel,
    onRemoveProject,
    isDisplayed,
}) => {
    const confirmationDialogContent = React.useMemo(() => {
        return (
            <>
                This action will permanently delete the product type from this
                family and inactivate all BPM listings upon publish.
            </>
        )
    }, [])

    return (
        <ConfirmationDialog
            dialogHeading={'Confirm Deletion'}
            openDialog={isDisplayed}
            handleDialogClose={onCancel}
            dialogActionCallback={onRemoveProject!}
            contentNode={confirmationDialogContent}
            size="small"
            confirmText="Delete"
        />
    )
}

export default RemoveProductTypeWarning
